import Markdown from 'react-markdown'

import './ai-markdown.scss'

// A study tutor's reply, rendered as Markdown (ChatWindow's markdownReplies). In E1 the chat
// showed replies as plain text, and two in three used Markdown anyway, so students read literal
// ** and backticks; from E2 the server's session notes tell the tutor that the chat renders it.
// Raw HTML is skipped, and links and images keep only their text: a reply cannot take the
// student off the exercise or load anything. Headings read as bold lines. The reply sits in the
// same bubble a plain message's <pre> draws (workspace.scss); its code blocks are not <pre>s,
// so that bubble's rules never reach them.
const Heading = ({ children }) => (
  <p>
    <strong>{children}</strong>
  </p>
)
const CodeBlock = ({ children }) => <div className="ws-ai-code">{children}</div>
const COMPONENTS = { h1: Heading, h2: Heading, h3: Heading, h4: Heading, h5: Heading, h6: Heading, pre: CodeBlock }
const NOT_RENDERED = ['a', 'img']

const AiMarkdown = ({ text }) => (
  <div className="ws-ai-markdown">
    <Markdown skipHtml disallowedElements={NOT_RENDERED} unwrapDisallowed components={COMPONENTS}>
      {text || ''}
    </Markdown>
  </div>
)

export default AiMarkdown
